export const MAP_STYLES = Object.freeze({
	SIMPLE: "map-style-simple",
	STANDARD: "map-style-standard",
	SATELLITE: "map-style-satellite",
	GOOGLE: "map-style-google-maps",
	MERN: "map-style-mern-qc",
})

export type MapStyleValue = (typeof MAP_STYLES)[keyof typeof MAP_STYLES]

export const PAGINATION_SIZE = 100

export {
	RANGE_SLIDER_MAX,
	RESIDENTIAL_UNITS_SLIDER_MIN,
	RESIDENTIAL_UNITS_SLIDER_MAX,
} from "@/views/viewFilterDefaults"

// Activity page pagination constants
export const ACTIVITY_PAGE = 1
export const ACTIVITY_PAGE_SIZE = 15
export const ACTIVITY_SIBLING_COUNT = 1
